import React from "react";
import { NewIconChatbot } from "@assets/icon";
import { ChatAgentType } from "@constants/chat-agents";
import "./ChatAdmin.scss";

interface ChatThinkingProps {
  activeAgent?: ChatAgentType;
}

const ChatThinking: React.FC<ChatThinkingProps> = ({ activeAgent }) => {
  const isCskhMode = activeAgent === ChatAgentType.CSKH;

  return (
    <div className={`chat-admin flex flex-col mt-[10px]${isCskhMode ? ' chat-admin--cskh' : ''}`}>
      <div className={`flex w-full ${isCskhMode ? 'items-start gap-3' : 'items-center'}`}>
        {isCskhMode && (
          <div className="chat-admin__avatar" aria-hidden>
            <NewIconChatbot />
          </div>
        )}
        <div className={isCskhMode ? 'border-chat-bot border-chat-bot--cskh' : 'mb-2 flex items-center'}>
          <span className="chat-responding-dots" role="status" aria-label="Đang trả lời">
            <span />
            <span />
            <span />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChatThinking;
